import { render, staticRenderFns } from "./ModalEditCompany.vue?vue&type=template&id=19ed0810"
import script from "./ModalEditCompany.vue?vue&type=script&lang=js"
export * from "./ModalEditCompany.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCompany.vue?vue&type=style&index=0&id=19ed0810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports